export const PERKBOX_MOBILE = 'PERKBOX_MOBILE';
